import { CheckFat } from '@phosphor-icons/react'
import {
  ArrowFatLineLeft,
  CaretDown,
  CaretUp,
  Gift,
  Minus,
  Plus,
  ShoppingCart,
  Trash,
} from 'phosphor-react'
import { Fragment, useEffect, useRef, useState } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import { createMessage } from '../../actions/messages'
import { setCarnetProfesional, setLinea } from '../../actions/modalGenerica'
import {
  actualizaPedido,
  deleteLinea,
  eliminarPedido,
  getPedidoActivo,
  nuevoPedido,
  setIdPedidoSeleccionado,
  getTextosVentas,
  integraPedido,
  postLinea,
  postLineas,
  setCorreoPedido,
  setHorarioEntrega,
} from '../../actions/pedidos'
import { getPrecios } from '../../actions/precios'
import { getPresentaciones } from '../../actions/presentaciones'
import { cargarArrayPrecios, cargarParametros, dynamicSort } from '../../helpers/funciones'
import { LONG_PEDIDO, campoExcedeLongitud } from '../../helpers/longitudesPedido'
import { creaURLArticulo } from '../../helpers/urls/articulos'
import i18n from '../../lang/idiomas'
import AnalyticsEdisa from '../common/AnalyticsEdisa'
import PagarRedsys from '../ecommerce/PagarRedsys'
import Spinner from '../layout/Spinner'
import Almacenes from './Almacenes'
import ArticuloNecesidades from './ArticuloNecesidades'
import BarraPortesCasals from './BarraPortesCasals'
import BotonAnadirLista from './BotonAnadirLista'
import BuscadorRapido from './BuscadorRapido'
import CorreoPedido from './CorreoPedido'
import Descripcion from './Descripcion'
import DomiciliosEnvio from './DomiciliosEnvio'
import FormasPago from './FormasPago'
import { calcularFechaDefault } from './HorarioEntrega'
import Imagen from './Imagen'
import NumeroPedidoCliente from './NumeroPedidoCliente'
import ObservacionesPedido from './ObservacionesPedido'
import { PayPalPayment } from './PayPalPayment'
import PersonaPedido from './PersonaPedido'
import PortesCasals from './PortesCasals'
import Precio from './Precio'
import Rutas from './Rutas'
import TarifasEnvioPortes from './TarifasEnvioPortes'
import TiposPedido from './TiposPedido'
import Transportistas from './Transportistas'

let parametros_usados = [
  'mostrar_iva',
  'tipo_precio',
  'andr_desc',
  'busc_rapido',
  'andr_a',
  'msg_tar_env',
  'tipo_msg_tar_env',
  'resumen_simple',
  'mostrar_pres',
  'estilo_precio',
]
let parametros
const ENVIAR_FECHA_ENTREGA = true

const Resumen = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const prevProps = useRef()

  const almacen_recogida = useSelector(state => state.almacenes.almacen)
  const carnets = useSelector(state => state.auth.user.carnets)
  const cookies = useSelector(state => state.portal.cookies)
  const domicilio_envio = useSelector(state => state.domiciliosEnvio.domicilio)
  // Provincias del estado elegido en la direccion del pedido: sirven para
  // comprobar que la pareja estado/provincia que se va a enviar es posible.
  const provincias = useSelector(state => state.provincias.provincias)
  const forma_envio = useSelector(state => state.formasEnvio.forma_envio)
  const forma_pago = useSelector(state => state.formasPago.forma_pago)
  const formas_pago = useSelector(state => state.formasPago.formas_pago)
  const hash = useSelector(state => state.auth.hash)
  const id_pedido_seleccionado = useSelector(state => state.pedidos.id_pedido_seleccionado)
  const lineas_pedido_cargando = useSelector(state => state.pedidos.isLoadingLines)
  const locale = useSelector(state => state.precios.locale)
  const moneda = useSelector(state => state.precios.moneda)
  const num_pedido = useSelector(state => state.pedidos.num_pedido)
  const numero_pres = useSelector(state => state.pedidos.numero_pres)
  const numero_serie_pres = useSelector(state => state.pedidos.numero_serie_pres)
  const pedido = useSelector(state => state.pedidos.pedido)
  const pedido_cargando = useSelector(state => state.pedidos.isLoading)
  const lineasModificadas = useSelector(state => state.pedidos.waitingUpdate)
  const portal = useSelector(state => state.portal.portal)
  const precios = useSelector(state => state.precios)
  const ponerPrecioManual = useSelector(state => state.precios.permisos?.puede_modificar_precio)
  const ponerDtoManual = useSelector(state => state.precios.permisos?.puede_modificar_descuento)
  const ruta = useSelector(state => state.rutas.ruta)
  const serie_pedido = useSelector(state => state.pedidos.serie_pedido)
  const tipo_pedido = useSelector(state => state.tiposPedido.tipo_pedido)
  const transportista = useSelector(state => state.transportistas.transportista)
  const user = useSelector(state => state.auth.user)
  const presentaciones = useSelector(state => state.presentaciones.presentaciones)

  const [state, setState] = useState({
    volver: '',
    articulos_carrito: [],
    importe_pedido: null,
    moneda: null,
    guardado: false,
    ver_resumen: true,
    modificado: false,
  })

  const isConfirmed = true

  parametros = cargarParametros(parametros_usados, portal.parametros_ecom, 'RES')

  useEffect(() => {
    dispatch(getTextosVentas(user['organizacion_comercial'], 'S', '01'))
    if (!pedido_cargando && !lineas_pedido_cargando) {
      dispatch(getPedidoActivo('', 'S', id_pedido_seleccionado || pedido.id_pedido))
      if (pedido?.lineas?.length > 0) {
        let aux_precios = cargarArrayPrecios('resumen', pedido.lineas, precios.precio)
        if (aux_precios.length > 0) {
          dispatch(getPrecios(aux_precios, 'resumen', pedido.domicilio_envio))
        }
      }
    }
    prevProps.current = { pedido }
    setState({ ...state, guardado: false })
    return () => {
      dispatch(getPedidoActivo('', 'N'))
    }
  }, [])

  useEffect(() => {
    if (ENVIAR_FECHA_ENTREGA && pedido?.id_pedido && !pedido?.reservado_alfa_2) {
      dispatch(setHorarioEntrega(calcularFechaDefault()))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pedido?.id_pedido])

  useEffect(() => {
    // Sacamos del carrito si este se queda sin lineas
    if (pedido?.lineas?.length === 0) {
      setState({ ...state, volver: 'S' })
    } else if (pedido?.lineas?.length > 0) {
      for (let lin of pedido.lineas) {
        if (!presentaciones[lin.articulo]) {
          // Si no están cargadas las posibles presentaciones del articulo las solicitamos
          dispatch(getPresentaciones(lin.articulo))
        }
      }
    }
  }, [pedido?.lineas])

  const getIdArticuloForLink = linea => {
    return linea
      ? encodeURIComponent(
          linea?.datos_articulo?.cod_padre || linea?.datos_articulo?.cod_padre === 0
            ? linea.datos_articulo.cod_padre
            : linea.articulo,
        )
      : ''
  }

  useEffect(() => {
    window.wookie()

    if (!pedido_cargando && !lineas_pedido_cargando) {
      // Iniciamos variables para eliminar los regalos del calculo
      if (!pedido?.id) {
        return
      }

      let lineas_pedido_actual_filtrado = pedido?.lineas.filter(linea => linea.tipo_linea !== 'R')
      let lineas_pedido_previo_filtrado = prevProps.current.pedido?.lineas.filter(
        linea => linea.tipo_linea !== 'R',
      )
      if (
        lineas_pedido_actual_filtrado &&
        lineas_pedido_previo_filtrado &&
        lineas_pedido_actual_filtrado.length !== lineas_pedido_previo_filtrado.length
      ) {
        // Si no coincide el tamano de los arrays
        dispatch(getPedidoActivo('', 'S', id_pedido_seleccionado || pedido.id_pedido))
      } else if (lineas_pedido_actual_filtrado?.length > 0) {
        let pido_lineas = false
        for (let linea of lineas_pedido_actual_filtrado) {
          //Si coincide buscamos que los articulos encajen
          let index = -1
          index = lineas_pedido_previo_filtrado.findIndex(
            linea_prev =>
              linea_prev.articulo === linea.articulo && linea_prev.tipo_linea === linea.tipo_linea,
          )

          if (index !== -1) {
            //Si coincide la linea
            if (
              linea.cantidad_pedida &&
              lineas_pedido_previo_filtrado[index].cantidad_pedida &&
              linea.cantidad_pedida !== lineas_pedido_previo_filtrado[index].cantidad_pedida
            ) {
              //Pedimos si no coincide la cantidad
              pido_lineas = true
              dispatch(getPedidoActivo('', 'S', id_pedido_seleccionado || pedido.id_pedido))
            }
          } else {
            //Pedimos si no se encuentra el articulo previo
            pido_lineas = true
            dispatch(getPedidoActivo('', 'S', id_pedido_seleccionado || pedido.id_pedido))
          }
        }
      }
    }
    prevProps.current = { pedido }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pedido_cargando, lineas_pedido_cargando, pedido])

  const changeQuantity = (e, linea) => {
    // currentTarget (no target) para que funcione aunque se pulse el icono SVG
    const contador = e.currentTarget.parentNode
    const input = contador.getElementsByClassName('quantity-input')[0]

    // Paso = UMS del artículo (múltiplo o cantidad mínima), por defecto 1
    const multiplo =
      parseInt(linea?.datos_articulo?.multiplo) ||
      parseInt(linea?.datos_articulo?.cantidad_minima) ||
      1

    const esBoton =
      e.currentTarget.className === 'plus-btn' || e.currentTarget.className === 'minus-btn'

    let count
    if (esBoton) {
      count =
        parseInt(input.value, 10) +
        (e.currentTarget.className === 'plus-btn' ? multiplo : -multiplo)
    } else {
      // Edición manual: redondea hacia arriba al múltiplo (misma lógica que en la ficha)
      const val = parseInt(input.value, 10) || multiplo
      count = Math.ceil(val / multiplo) * multiplo
    }

    let value = Math.max(count, multiplo)
    if (parseInt(linea.cantidad_pedida) !== value) {
      let cantidad_prev = linea.cantidad_pedida
      linea.cantidad_pedida = value
      input.value = value
      dispatch(
        postLinea(linea, hash, id_pedido_seleccionado || pedido.id_pedido, 'S', cantidad_prev),
      )
      // Repedimos el precio con presentacion_web (como el listado/carrito) para que
      // LISA recalcule el color del badge (reservado_a01) según la cantidad
      dispatch(
        getPrecios(
          [
            {
              codigo_articulo: linea.articulo,
              cantidad: value,
              presentacion: linea?.datos_articulo?.presentacion_web || linea.presentacion_pedido,
            },
          ],
          'resumen',
          pedido.domicilio_envio,
        ),
      )
    }
  }

  const onChange = e => {
    setState({ ...state, observaciones: e.target.value })
  }

  const pedirConfirmacion = e => {
    e.preventDefault()
    let mensaje = ''
    let titulo = ''

    if (
      pedido?.lineas?.some(linea => linea.tipo_linea === 'O') &&
      pedido?.lineas?.some(linea => linea.tipo_linea === 'P')
    ) {
      titulo = i18n.t('resumen.resfnppt').toLocaleUpperCase()
      mensaje = i18n.t('resumen.resfnppm')
    } else if (
      pedido?.lineas.every(linea => linea.tipo_linea === 'O' || linea.tipo_linea === 'R')
    ) {
      titulo = i18n.t('resumen.resfnprt').toLocaleUpperCase()
      mensaje = i18n.t('resumen.resfnprm')
    } else if (
      pedido?.lineas.every(linea => linea.tipo_linea === 'P' || linea.tipo_linea === 'R')
    ) {
      titulo = i18n.t('resumen.resfnpdt').toLocaleUpperCase()
      mensaje = i18n.t('resumen.resfnpdm')
    }

    confirmAlert({
      title: titulo,
      message: mensaje,
      closeOnEscape: false,
      closeOnClickOutside: false,
      buttons: [
        {
          label: i18n.t('general.aceptar'),
          onClick: () => {
            integrarPedido()
          },
        },
        {
          label: i18n.t('general.cancelar'),
          onClick: () => {},
        },
      ],
    })
  }

  const integrarPedido = () => {
    if (comprobarPedido()) {
      dispatch(
        integraPedido(
          {
            ...domicilio_envio,
            reservado_alfa_1: pedido.reservado_alfa_1,
          },
          pedido.observaciones,
          forma_envio,
          almacen_recogida,
          ruta,
          forma_pago,
          pedido,
          'N',
          id_pedido_seleccionado || pedido.id_pedido,
          '',
          pedido.persona_pedido,
          pedido.pedido_cliente,
          {
            nombre_dom_envio: pedido.nombre_dom_envio,
            direccion_dom_envio: pedido.direccion_dom_envio,
            localidad_dom_envio: pedido.localidad_dom_envio,
            estado_dom_envio: pedido.estado_dom_envio,
            provincia_dom_envio: pedido.provincia_dom_envio,
            cod_postal_dom_envio: pedido.cod_postal_dom_envio,
            tipo_portes_dom_envio: pedido.tipo_portes_dom_envio,
            reservado_alfa_1: pedido.reservado_alfa_1,
          },
          pedido.email,
          transportista,
          pedido.reservado_alfa_3,
        ),
      )

      if (
        Object.keys(portal.parametros_seo).length > 0 &&
        cookies.acepta_cookies &&
        cookies.analiticas
      ) {
        let articulos_carrito = []
        pedido.lineas.forEach(linea => {
          articulos_carrito.push(linea.articulo)
        })

        let importe_pedido = Number.parseFloat(
          pedido.lineas
            .map(linea => {
              return linea.importe_neto_lin
            })
            .reduce((accumulator, currentValue) => accumulator + currentValue),
        ).toFixed(precios.decimales_pvp)

        let precioMoneda = precios.precio.moneda

        setState({
          ...state,
          articulos_carrito: articulos_carrito,
          importe_pedido: importe_pedido,
          moneda: precioMoneda,
        })

        let analytics = new AnalyticsEdisa()
        analytics.registraEvento({
          modulo: 'Pedido',
          tipo: 'InitiateCheckout',
          valor: importe_pedido,
          params: {
            articulo: articulos_carrito,
            divisa: precioMoneda,
            precio: importe_pedido,
          },
        })
      }
    }
  }
  const validarCorreos = correos => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return correos.split(',').every(c => regex.test(c.trim()))
  }

  // Etiqueta de cada campo para el mensaje de longitud excedida
  const etiquetaCampoPedido = campo =>
    ({
      persona_pedido: i18n.t('pedido.ppersped', 'Persona pedido'),
      pedido_cliente: i18n.t('pedido.numpedcl', 'Núm. pedido cliente'),
      reservado_alfa_3: i18n.t('general.corlabel', 'Correo'),
      observaciones: i18n.t('pedido.pobsrped', 'Observaciones del pedido'),
      nombre_dom_envio: i18n.t('domicilios.nombre', 'Nombre'),
      direccion_dom_envio: i18n.t('domicilios.direc', 'Dirección'),
      localidad_dom_envio: i18n.t('domicilios.local', 'Localidad'),
      cod_postal_dom_envio: i18n.t('domicilios.codpstal', 'Código postal'),
    })[campo] || campo

  const comprobarPedido = () => {
    // Comprobamos si el pedido está cargando
    if (pedido_cargando) return false

    // Campos con más caracteres de los que admiten MySQL / LIBRA
    const campoLargo = campoExcedeLongitud(pedido)

    if (pedido.lineas?.some(linea => linea?.datos_articulo?.hay_disponibilidad === 'N')) {
      dispatch(createMessage(i18n.t('nostklin'), 'error'))
      return false
    }

    //Comprobamos la forma de envio
    if (!forma_envio.tipo) {
      dispatch(createMessage(i18n.t('resumen.resfalfe'), 'error'))

      // Si se ha cambiado el estado de la direccion del pedido, la provincia
      // tiene que ser una de ese estado. Al servidor un valor vacio no le
      // borra la provincia anterior (pedidos_fn.domicilio_envio_mod usa "or"),
      // asi que sin esta comprobacion se podria enviar a Libra un estado nuevo
      // con la provincia del anterior.
      //
      // Solo se comprueba cuando el estado elegido no es el del domicilio de la
      // ficha, es decir, cuando el usuario ha cambiado de pais. La pareja
      // (estado, provincia) de un domicilio puede no existir en el maestro
      // local -- se sincroniza desde Libra y no hay integridad referencial (ver
      // DomiciliosEnvioSerializer) -- y no se puede bloquear un pedido que hoy
      // se tramita sin problema.
    } else if (
      forma_envio.tipo === 'D' &&
      pedido.estado_dom_envio &&
      pedido.estado_dom_envio !== domicilio_envio.estado &&
      provincias?.length > 0 &&
      !provincias.some(prov => prov.provincia === pedido.provincia_dom_envio)
    ) {
      dispatch(
        createMessage(
          i18n.t('resumen.resfalpr', 'Debe indicar la provincia de la dirección de envío'),
          'error',
        ),
      )

      // Comprobamos el domicilio de envio
    } else if (
      forma_envio.tipo === 'D' &&
      (domicilio_envio.numero_direccion === null ||
        domicilio_envio.numero_direccion === '' ||
        domicilio_envio.numero_direccion === undefined)
    ) {
      dispatch(createMessage(i18n.t('resumen.resfalde'), 'error'))

      // Caso 1825006: un nuevo domicilio de envio empieza con los campos a ''
      // (null = sin domicilio nuevo). Un campo vacio no puede llegar al
      // servidor: pedidos_fn.domicilio_envio_mod lo rellenaria con el dato del
      // domicilio base y la direccion de entrega quedaria mezclada.
    } else if (
      forma_envio.tipo === 'D' &&
      [
        pedido.nombre_dom_envio,
        pedido.direccion_dom_envio,
        pedido.localidad_dom_envio,
        pedido.cod_postal_dom_envio,
        pedido.estado_dom_envio,
        pedido.provincia_dom_envio,
      ].some(valor => typeof valor === 'string' && valor.trim() === '')
    ) {
      dispatch(
        createMessage(
          i18n.t('resumen.resfalnd', 'Complete los datos del nuevo domicilio de envío'),
          'error',
        ),
      )

      //Comprobamos el lugar de recogida
    } else if (forma_envio.tipo === 'T' && !almacen_recogida.almacen) {
      dispatch(createMessage(i18n.t('resumen.resfallr'), 'error'))

      //Comprobamos la ruta
    } else if (forma_envio.tipo === 'R' && !ruta.almacen) {
      dispatch(createMessage(i18n.t('resumen.resfalrr'), 'error'))

      // Comprobamos la forma de pago
    } else if (formas_pago.length > 0 && !forma_pago.codigo_forma_pago_web) {
      dispatch(createMessage(i18n.t('resumen.resfalfp'), 'error'))

      // Persona pedido obligatoria
    } else if (!pedido.persona_pedido?.trim()) {
      dispatch(
        createMessage(i18n.t('resumen.resfalpp', 'Debe indicar la persona del pedido'), 'error'),
      )

      // Longitud máxima de los campos de fin de pedido
    } else if (campoLargo) {
      dispatch(
        createMessage(
          i18n.t('resumen.reslonmx', {
            defaultValue: 'El campo {{campo}} no puede superar {{max}} caracteres',
            campo: etiquetaCampoPedido(campoLargo),
            max: LONG_PEDIDO[campoLargo],
          }),
          'error',
        ),
      )
    } else if (!pedido.reservado_alfa_3 || !pedido.reservado_alfa_3.trim()) {
      dispatch(
        createMessage(i18n.t('resumen.resfalco', 'Debe indicar un correo electrónico'), 'error'),
      )
    } else if (!validarCorreos(pedido.reservado_alfa_3)) {
      dispatch(
        createMessage(
          i18n.t(
            'peticion_codigo_postal.corrinco',
            'El correo electrónico introducido no tiene un formato válido',
          ),
          'error',
        ),
      )
    } else {
      return true
    }
  }
  const handleEliminarPedido = e => {
    e.preventDefault()
    if (!pedido_cargando) {
      confirmAlert({
        title: i18n.t('carrito.crrbort').toUpperCase(),
        message: i18n.t('carrito.crrborm'),
        closeOnEscape: true,
        closeOnClickOutside: true,
        buttons: [
          {
            label: i18n.t('general.si'),
            onClick: () => {
              dispatch(
                eliminarPedido(pedido.id_pedido, '', id_pedido_seleccionado || pedido.id_pedido),
              )
              setState({ ...state, volver: 'S' })
            },
          },
          {
            label: i18n.t('general.no'),
          },
        ],
      })
    }
  }

  const eliminarLinea = e => {
    e.preventDefault()
    if (!pedido_cargando && !state.guardado) {
      const linea_seleccionada = e.currentTarget.dataset.linea
      confirmAlert({
        title: i18n.t('resumen.reselmat').toUpperCase(),
        message: i18n.t('resumen.reselmam'),
        closeOnEscape: true,
        closeOnClickOutside: true,
        buttons: [
          {
            label: i18n.t('general.si'),
            onClick: () =>
              dispatch(
                deleteLinea(linea_seleccionada, hash, id_pedido_seleccionado || pedido.id_pedido),
              ),
          },
          {
            label: i18n.t('general.no'),
          },
        ],
      })
    }
  }

  const mostrar_resumen = e => {
    e.preventDefault()
    state.ver_resumen
      ? setState({ ...state, ver_resumen: false, modificado: true })
      : setState({ ...state, ver_resumen: true, modificado: true })
  }

  const finalizar = () => {
    const info_pedido =
      serie_pedido && serie_pedido !== '' && num_pedido && num_pedido !== ''
        ? serie_pedido + '/' + num_pedido
        : ''

    const info_pres =
      numero_serie_pres && numero_serie_pres !== '' && numero_pres && numero_pres !== ''
        ? numero_serie_pres + '/' + numero_pres
        : ''

    let mensaje = ''
    let titulo = ''
    if (info_pedido !== '' && info_pres !== '') {
      mensaje =
        i18n.t('resumen.resmokf1') +
        info_pedido +
        i18n.t('resumen.resmokf2') +
        info_pres +
        i18n.t('resumen.resmokf3') +
        '\n' +
        i18n.t('resumen.resmokf4')
      titulo = i18n.t('resumen.restokf').toLocaleUpperCase()
    } else if (info_pedido !== '' && info_pres === '') {
      mensaje =
        i18n.t('resumen.resmokf1') +
        info_pedido +
        i18n.t('resumen.resmokf3') +
        '\n' +
        i18n.t('resumen.resmokf4')
      titulo = i18n.t('resumen.restokf1').toLocaleUpperCase()
    } else if (info_pedido === '' && info_pres !== '') {
      mensaje =
        i18n.t('resumen.resmokf0') +
        info_pres +
        i18n.t('resumen.resmokf3') +
        '\n' +
        i18n.t('resumen.resmokf4')
      titulo = i18n.t('resumen.restokf2').toLocaleUpperCase()
    }

    confirmAlert({
      title: titulo,
      message: mensaje,
      closeOnEscape: false,
      closeOnClickOutside: false,
      buttons: [
        {
          label: i18n.t('general.aceptar'),
          onClick: () => {
            let analytics = new AnalyticsEdisa()
            analytics.registraEvento({
              modulo: 'Pedido',
              tipo: 'Purchase',
              valor: state.importe_pedido,
              params: {
                articulos: state.articulos_carrito,
                divisa: state.moneda,
                precio: state.importe_pedido,
              },
            })
            setState({ ...state, volver: 'S' })
          },
        },
      ],
    })
  }

  const actualizarPedido = e => {
    e.preventDefault()
    console.log({
      pedido_cargando,
      domicilio_envio,
      forma_envio,
    })

    if (comprobarPedido()) {
      dispatch(
        actualizaPedido(
          {
            ...domicilio_envio,
          },
          forma_envio,
          almacen_recogida,
          ruta,
          hash,
          tipo_pedido,
          id_pedido_seleccionado || pedido.id_pedido,
          '',
          pedido.observaciones,
          pedido.persona_pedido,
          pedido.pedido_cliente,
          {
            nombre_dom_envio: pedido.nombre_dom_envio,
            direccion_dom_envio: pedido.direccion_dom_envio,
            localidad_dom_envio: pedido.localidad_dom_envio,
            estado_dom_envio: pedido.estado_dom_envio,
            provincia_dom_envio: pedido.provincia_dom_envio,
            cod_postal_dom_envio: pedido.cod_postal_dom_envio,
            tipo_portes_dom_envio: pedido.tipo_portes_dom_envio,
          },
          pedido.email,
          transportista,
          pedido.reservado_alfa_3,
          forma_pago,
          pedido.reservado_alfa_1,
          pedido.reservado_alfa_2,
        ),
      )
      setState({ ...state, guardado: true })
    }
  }

  const modificarPedido = e => {
    e.preventDefault()
    setState({ ...state, guardado: false, ver_resumen: true, modificado: true })
  }

  const modificarObs = (linea, origen) => {
    dispatch(setLinea(linea, origen))
  }

  const devuelveDatosLineas = tipo_linea => {
    if (lineas_pedido_cargando) {
      return <Spinner showSpinner={lineas_pedido_cargando} />
    } else if (pedido?.lineas?.length > 0 && parametros) {
      return pedido.lineas
        .sort(dynamicSort('numero_linea'))
        .filter(linea => {
          return filtrarLineas(tipo_linea, linea)
        })
        .map(linea => {
          return (
            <div
              className={
                'linea-carrito tipo-linea-' +
                linea.tipo_linea +
                (linea.tipo_articulo ? ' tipo-articulo-' + linea.tipo_articulo : '')
              }
              key={linea.id}>
              <div className='linea-img'>{devuelveImagenLin(linea)}</div>

              <div className='linea-info'>
                <div className='linea-ref'>{devuelveCodigo(linea)}</div>
                <div className='linea-nombre'>{devuelveDescripcion(linea)}</div>
                <div className='linea-precio-ud'>{devuelvePrecioLin(linea)}</div>
                {ponerDtoManual && !state.guardado ? (
                  <div className='linea-dto'>{devuelveDescuentoLin(linea)}</div>
                ) : (
                  ''
                )}
                {linea.tipo_linea !== 'R' && (
                  <div
                    className='linea-badges'
                    dangerouslySetInnerHTML={{
                      __html:
                        precios.precio?.[linea.articulo]?.[
                          linea?.datos_articulo?.presentacion_web ||
                            linea.presentacion_escogida ||
                            linea.presentacion_pedido
                        ]?.reservado_a01 || '',
                    }}
                  />
                )}
                {linea?.datos_articulo?.hay_disponibilidad === 'N' && (
                  <div className='linea-stock-alert'>
                    {i18n.t('stkinsuf', 'No hay stock suficiente de este artículo')}
                  </div>
                )}
                {devuelveNecesidades(linea)}
              </div>

              <div className='linea-qty'>{devuelveInfoCantidad(linea)}</div>

              <div className='linea-total'>{devuelveTotalLin(tipo_linea, linea)}</div>

              <div className='linea-del'>{devuelveBotonesLinea(linea)}</div>
            </div>
          )
        })
    } else {
      return ''
    }
  }

  const devuelveLineas = tipo_linea => {
    const numProductos = pedido?.lineas?.filter(l => l.tipo_linea === 'P').length || 0
    return (
      <div className='checkout-card'>
        <div className='checkout-card-header'>
          <span className='checkout-card-ico'>
            <ShoppingCart
              size={18}
              weight='bold'
            />
          </span>
          <div className='checkout-card-heading'>
            <h4 className='checkout-card-title'>
              {tipo_linea === 'presupuesto' ? i18n.t('general.presup') : i18n.t('resumen.titdarts')}
            </h4>
            {tipo_linea === 'pedido' ? (
              <p className='checkout-card-sub'>
                {numProductos}{' '}
                {numProductos === 1
                  ? i18n.t('general.producto', 'producto')
                  : i18n.t('general.productos', 'productos')}{' '}
                · {i18n.t('resumen.subdarts')}
              </p>
            ) : (
              ''
            )}
          </div>
          {tipo_linea === 'pedido' ? (
            <button
              type='button'
              className='btn-vaciar-carrito'
              onClick={handleEliminarPedido}
              title={i18n.t('carrito.crrbort')}>
              <Trash size={16} />
              <span>{i18n.t('carrito.crrbort')}</span>
            </button>
          ) : (
            ''
          )}
        </div>
        <div className={'lineas-' + tipo_linea + ' row tt-shopcart-table'}>
          <div className='col'>{devuelveDatosLineas(tipo_linea)}</div>
        </div>
        {tipo_linea === 'pedido' ? <BarraPortesCasals /> : ''}
      </div>
    )
  }

  const filtrarLineas = (tipo_linea, linea) => {
    if (tipo_linea === 'presupuesto') {
      return (
        linea.tipo_linea === 'O' ||
        pedido?.lineas?.some(
          linea_padre =>
            linea_padre.numero_linea === linea.numero_linea_origen &&
            linea_padre.tipo_linea === 'O',
        )
      )
    } else if (tipo_linea === 'pedido') {
      return (
        linea.tipo_linea === 'P' ||
        pedido?.lineas?.some(
          linea_padre =>
            linea_padre.numero_linea === linea.numero_linea_origen &&
            linea_padre.tipo_linea === 'P',
        ) ||
        linea.tipo_linea === 'R'
      )
    } else return false
  }

  const devuelveImagenLin = linea => {
    if (linea.tipo_articulo !== 'F') {
      return (
        <Link
          to={creaURLArticulo(
            linea?.datos_articulo?.cod_padre || linea.articulo,
            linea?.descripcion,
          )}>
          <div className='tt-product-img'>
            <Imagen
              codigo_articulo={linea.articulo}
              principal='S'
              numero_imagen={1}
              src_manual={linea?.datos_articulo?.reservado_alfa_2 || null}
            />
          </div>
        </Link>
      )
    } else {
      return (
        <div className='tt-product-img'>
          <Imagen
            codigo_articulo={linea.articulo}
            principal='S'
            numero_imagen={1}
            src_manual={linea?.datos_articulo?.reservado_alfa_2 || null}
          />
        </div>
      )
    }
  }

  const devuelveCodigo = linea => {
    if (linea.tipo_articulo !== 'F') {
      return (
        <div className='row desc-cod'>
          <Link
            to={creaURLArticulo(
              linea?.datos_articulo?.cod_padre || linea.articulo,
              linea?.descripcion,
            )}>
            {linea.articulo}
          </Link>
        </div>
      )
    } else {
      return <div className='row desc-cod'>{linea.articulo}</div>
    }
  }

  const devuelveDescripcion = linea => {
    if (linea.tipo_articulo !== 'F') {
      return (
        <div className='row desc-des'>
          <Link
            to={creaURLArticulo(
              linea?.datos_articulo?.cod_padre || linea.articulo,
              linea?.descripcion,
            )}>
            <Descripcion codigo_articulo={linea.articulo} />
          </Link>
        </div>
      )
    } else {
      return (
        <div className='row desc-des'>
          <Descripcion codigo_articulo={linea.articulo} />
        </div>
      )
    }
  }

  const devuelveNecesidades = linea => {
    return (
      <div className='row des-nec'>
        {linea.datos_articulo ? (
          <ArticuloNecesidades
            articulo={linea.datos_articulo}
            origen='resumen'
            carnets={carnets}
            user={user}
            setCarnetProfesional={setCarnetProfesional}
          />
        ) : (
          ''
        )}
      </div>
    )
  }

  const devuelveInfoCantidad = linea => {
    if (linea.sub_pres) {
      return linea.sub_pres_cant + ' X ' + linea.sub_pres
    }

    const editable =
      linea.tipo_articulo !== 'R' &&
      linea.tipo_articulo !== 'T' &&
      linea.tipo_articulo !== 'F' &&
      !state.guardado

    return (
      <div className='detach-quantity-desctope info-cantidad'>
        <div className='qty-selector'>
          {editable ? (
            <button
              type='button'
              className='minus-btn'
              onClick={e => changeQuantity(e, linea)}>
              <Minus
                size={14}
                weight='bold'
              />
            </button>
          ) : (
            ''
          )}
          <input
            className='quantity-input input-cantidad-resumen'
            type='text'
            defaultValue={Number.parseFloat(linea.cantidad_pedida).toFixed(0)}
            onBlur={e => {
              e.preventDefault()
              changeQuantity(e, linea)
            }}
            size='5'
            data-articulo={linea.articulo}
            data-presentacion_pedido={linea.presentacion_pedido}
            data-descripcion={linea.descripcion}
            readOnly={!editable}
          />
          {editable ? (
            <button
              type='button'
              className='plus-btn'
              onClick={e => changeQuantity(e, linea)}>
              <Plus
                size={14}
                weight='bold'
              />
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    )
  }

  const devuelveBotonObservaciones = linea => {
    if (
      linea.tipo_articulo !== 'R' &&
      linea.tipo_articulo !== 'T' &&
      linea.tipo_articulo !== 'F' &&
      !state.guardado
    ) {
      return <></>

      /**{
        
        <div className='botonera-mod'>
          <button
            className='btn modificar-obs'
            onClick={() => modificarObs(linea, 'lin-ped-obs')}>
            <Note
              size={20}
              alt={i18n.t('general.altaddob')}
            />
          </button>
        </div>
      }**/
    }
  }
  const devuelvePrecioLin = linea => {
    if (linea.tipo_linea !== 'R') {
      return (
        <Precio
          origen={ponerPrecioManual && !state.guardado ? 'resumen' : null}
          linea={ponerPrecioManual && !state.guardado ? linea : null}
          codigo_articulo={linea.articulo}
          presentacion={linea.presentacion_escogida || linea.presentacion_pedido}
          // precio_manual={Number.parseFloat(linea.importe_neto_lin)}
          mostrar_iva={'N'}
          mostrar_pres={ponerPrecioManual ? 'N' : parametros.mostrar_pres}
          tipo_precio={'bruto'}
          estilo_precio={parametros.estilo_precio}
        />
      )
    } else {
      return (
        <Precio
          codigo_articulo={linea.articulo}
          presentacion={linea.presentacion_escogida || linea.presentacion_pedido}
          // precio_manual={0}
          tipo_precio={'un_sin_iva'}
          mostrar_iva={'N'}
        />
      )
    }
  }

  const devuelveDescuentoLin = linea => {
    if (linea.tipo_linea !== 'R') {
      return (
        <Precio
          codigo_articulo={linea.articulo}
          origen={ponerDtoManual && !state.guardado ? 'resumen' : null}
          linea={ponerDtoManual && !state.guardado ? linea : null}
          presentacion={linea.presentacion_escogida || linea.presentacion_pedido}
          precio_manual={Number.parseFloat(linea.dto_1 || 0)}
          tipo_precio={'descuento'}
          mostrar_iva={parametros.mostrar_iva}
          añadir_descuento={ponerDtoManual && !state.guardado ? null : parametros.andr_desc}
          mostrar_pres={'N'}
          estilo_precio={parametros.estilo_precio}
        />
      )
    } else {
      return ''
    }
  }

  const devuelveTotalLin = (tipo_linea, linea) => {
    if (tipo_linea === 'pedido') {
      return (
        <span className='tt-price subtotal'>
          {linea.tipo_linea !== 'R' ? (
            <Precio
              codigo_articulo={linea.articulo}
              presentacion={linea.presentacion_escogida || linea.presentacion_pedido}
              precio_manual={Number.parseFloat(linea.importe_neto_lin)}
              tipo_precio={'mixto'}
              mostrar_iva={parametros.mostrar_iva}
              mostrar_pres={linea.precio_manual === 'S' ? 'N' : parametros.mostrar_pres}
              estilo_precio={parametros.estilo_precio}
            />
          ) : (
            <Gift size={20} />
          )}
        </span>
      )
    }
  }

  const devuelveBotonesLinea = linea => {
    if (
      linea.tipo_linea !== 'R' &&
      linea.tipo_articulo !== 'R' &&
      linea.tipo_articulo !== 'T' &&
      linea.tipo_articulo !== 'F' &&
      !state.guardado
    ) {
      return (
        <>
          <button
            className='btn-borrar-linea'
            data-linea={linea.id}
            onClick={eliminarLinea}>
            <Trash size={20} />
            <span className='ocultar'>{i18n.t('general.cerrar')}</span>
          </button>
        </>
      )
    }
  }

  let es_pedido = true
  let es_presupuesto = false
  if (
    pedido &&
    Object.keys(pedido).length > 0 &&
    pedido.lineas &&
    pedido?.lineas?.some(linea => linea.tipo_linea === 'P')
  ) {
    es_pedido = true
  } else {
    es_pedido = false
  }

  if (
    pedido &&
    Object.keys(pedido).length > 0 &&
    pedido.lineas &&
    pedido?.lineas?.some(linea => linea.tipo_linea === 'O')
  ) {
    es_presupuesto = true
  } else {
    es_presupuesto = false
  }

  if (parametros.resumen_simple === 'S' && state.modificado === false) {
    if (!state.guardado || !state.ver_resumen) {
      // Si el parametro es S saltamos el 1er paso
      setState({ ...state, guardado: true, ver_resumen: true })
    }
  }
  const { volver } = state
  if (
    ((!pedido?.lineas || pedido.lineas.length === 0) &&
      num_pedido === '' &&
      serie_pedido === '' &&
      numero_pres === '' &&
      numero_serie_pres === '') ||
    volver === 'S'
  ) {
    return <Navigate to='/' />
  } else if (
    Object.keys(pedido).length === 0 &&
    ((num_pedido !== '' && serie_pedido !== '') || (numero_pres !== '' && numero_serie_pres !== ''))
  ) {
    finalizar()
  } else if (Object.keys(pedido).length !== 0 && num_pedido !== '' && serie_pedido !== '') {
    if (forma_pago.pasarela && forma_pago.pasarela !== '') {
      switch (forma_pago.pasarela) {
        case 'WOMPI':
          return (
            <Navigate
              to={{
                pathname: '/wompi',
                state: {
                  articulos_carrito: state.articulos_carrito,
                  moneda: state.moneda,
                  importe_pedido: state.importe_pedido,
                },
              }}
            />
          )
        case 'CARDNET':
          return (
            <Navigate
              to={{
                pathname: '/cardnet',
                state: {
                  articulos_carrito: state.articulos_carrito,
                  moneda: state.moneda,
                  importe_pedido: state.importe_pedido,
                },
              }}
            />
          )

        default:
          break
      }
    }
  }
  // const { volver } = this.state;
  // if (
  //   (this.props.pedido?.lineas?.length === 0 && this.props.num_pedido === "" && this.props.serie_pedido === "" && this.props.numero_pres === "" && this.props.numero_serie_pres === "") ||
  //   volver === "S"
  // ) {
  //   return <Navigate to="/" />;
  // } else if (
  //   Object.keys(this.props.pedido).length === 0 &&
  //   ((this.props.num_pedido !== "" && this.props.serie_pedido !== "") || (this.props.numero_pres !== "" && this.props.numero_serie_pres !== ""))
  // ) {
  //   this.finalizar();
  // } else if (Object.keys(this.props.pedido).length !== 0 && this.props.num_pedido !== "" && this.props.serie_pedido !== "") {
  //   if (this.props.forma_pago.pasarela && this.props.forma_pago.pasarela !== "") {
  //     switch (this.props.forma_pago.pasarela) {
  //       case "WOMPI":
  //         return (
  //           <Navigate
  //             to={{
  //               pathname: "/wompi",
  //               state: {
  //                 articulos_carrito: this.state.articulos_carrito,
  //                 moneda: this.state.moneda,
  //                 importe_pedido: this.state.importe_pedido,
  //               },
  //             }}
  //           />
  //         );
  //       case "CARDNET":
  //         return (
  //           <Navigate
  //             to={{
  //               pathname: "/cardnet",
  //               state: {
  //                 articulos_carrito: this.state.articulos_carrito,
  //                 moneda: this.state.moneda,
  //                 importe_pedido: this.state.importe_pedido,
  //               },
  //             }}
  //           />
  //         );

  const devuelveBuscador = () => {
    if (pedido && !state.guardado && parametros.busc_rapido && parametros.busc_rapido !== 'N') {
      return (
        <div className='row buscador-carrito'>
          <div className='col-sm-12 col-md-12 col-lg-12'>
            <BuscadorRapido añadir_a={parametros.andr_a} />
          </div>
        </div>
      )
    }
  }

  const devuelveTotales = () => {
    if (pedido_cargando || lineas_pedido_cargando) return

    const fmt = valor =>
      new Intl.NumberFormat(locale, { style: 'currency', currency: moneda }).format(valor)

    const sumarLineas = campo =>
      !pedido.lineas || pedido.lineas.length === 0
        ? 0
        : Number.parseFloat(
            pedido.lineas
              .filter(linea => linea.tipo_linea === 'P')
              .map(linea => Number.parseFloat(linea[campo]))
              .reduce((acc, cur) => acc + cur, 0),
          )

    const sinImpuestos =
      pedido.total_pedido != null
        ? pedido.total_pedido
        : sumarLineas('importe_neto_lin')

    return (
      <div className='totales'>
        <div className='resumen-card'>
          <h4 className='resumen-card-title'>{i18n.t('resumen.carcompr')}</h4>

          {lineasModificadas && !state.guardado ? (
            <button
              className='btn-link actualizar-lineas-btn'
              onClick={e => {
                e.preventDefault()
                dispatch(postLineas(pedido.lineas, hash, pedido, null))
              }}>
              <CheckFat size={18} />
              <span>{i18n.t('carrito.crractu').toUpperCase()}</span>
            </button>
          ) : (
            ''
          )}

          <div className='resumen-row resumen-row-final'>
            <span className='resumen-label'>{i18n.t('general.total').toUpperCase()}</span>
            <span className='resumen-value'>{fmt(sinImpuestos)}</span>
          </div>
        </div>
      </div>
    )
  }

  const devuelveTextoBoton = (es_pedido, es_presupuesto) => {
    if (es_pedido && es_presupuesto) {
      return i18n.t('general.pedyprp')
    } else if (es_pedido && !es_presupuesto) {
      return i18n.t('general.pedido')
    } else if (!es_pedido && es_presupuesto) {
      return i18n.t('general.presup')
    } else {
      return i18n.t('general.carrito').toUpperCase()
    }
  }

  const handleNuevoPedido = async e => {
      e.preventDefault()

      dispatch(setIdPedidoSeleccionado(''))
      const pedidoNuevo = await dispatch(nuevoPedido())
      dispatch(getPedidoActivo('', 'S', pedidoNuevo?.id_pedido))
    }

  const handleSeguirComprando = e => {
    e.preventDefault()

    if (pedido_cargando) return

    dispatch(
      actualizaPedido(
        { ...domicilio_envio },
        forma_envio,
        almacen_recogida,
        ruta,
        hash,
        tipo_pedido,
        id_pedido_seleccionado || pedido.id_pedido,
        '',
        pedido.observaciones,
        pedido.persona_pedido,
        pedido.pedido_cliente,
        {
          nombre_dom_envio: pedido.nombre_dom_envio,
          direccion_dom_envio: pedido.direccion_dom_envio,
          localidad_dom_envio: pedido.localidad_dom_envio,
          estado_dom_envio: pedido.estado_dom_envio,
          provincia_dom_envio: pedido.provincia_dom_envio,
          cod_postal_dom_envio: pedido.cod_postal_dom_envio,
          tipo_portes_dom_envio: pedido.tipo_portes_dom_envio,
        },
        pedido.email,
        transportista,
        pedido.reservado_alfa_3,
        forma_pago,
        pedido.reservado_alfa_1,
        pedido.reservado_alfa_2,
        () => navigate('/articulos'),
      ),
    )
  }

  return (
    <Fragment>
      <div className='container'>
        <div id='tt-pageContent'>
          <div className='container-indent'>
            {pedido_cargando || parametros === undefined || parametros === null ? (
              <Spinner showSpinner={pedido_cargando} />
            ) : (
              <div className='container'>
                <div className='checkout-grid'>
                  <div className='checkout-main'>
                    <div className='row'>
                      <div className='col-sm-12 col-md-12 col-lg-12'>
                        <>
                          {devuelveBuscador()}
                          {pedido?.id_pedido ? (
                            <h2 className='tt-title pedido-id-title'>
                              {i18n.t('resumen.numpedid')}{pedido.id_pedido}
                            </h2>
                          ) : (
                            ''
                          )}
                          {pedido && Object.keys(pedido).length > 0 && pedido.lineas ? (
                            pedido?.lineas?.some(linea => linea.tipo_linea === 'P') ? (
                              <>
                                {devuelveLineas('pedido')}
                                <TarifasEnvioPortes
                                  mostrar_mensaje={parametros.msg_tar_env}
                                  tipo_tarifa={parametros.tipo_msg_tar_env}
                                />
                              </>
                            ) : (
                              ''
                            )
                          ) : (
                            ''
                          )}

                          {pedido &&
                          Object.keys(pedido).length > 0 &&
                          pedido?.lineas?.some(linea => linea.tipo_linea === 'O') ? (
                            <Fragment>{devuelveLineas('presupuesto')}</Fragment>
                          ) : (
                            ''
                          )}
                        </>
                      </div>
                    </div>
                    <div className='row tt-shopcart-btn'>
                      <div className='col-sm-12 col-md-4 col-lg-4 añadir'>
                        {pedido.lineas &&
                        pedido.lineas.filter(linea => linea.tipo_linea === 'P').length > 0 ? (
                          <BotonAnadirLista
                            origen='resumen'
                            lineas={pedido.lineas.filter(linea => linea.tipo_linea === 'P')}
                          />
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 col-md-12 col-xl-12'>
                        <div className='tt-shopcart-wrapper'>
                          <div
                            className='row mostrar_resumen_btn'
                            style={state.guardado ? { display: 'block' } : { display: 'none' }}>
                            {state.ver_resumen ? (
                              <button
                                className='btn-link mostrar-res'
                                onClick={mostrar_resumen}>
                                <span>{i18n.t('resumen.resocurs')}</span>
                                <CaretUp
                                  size={18}
                                  weight='bold'
                                />
                              </button>
                            ) : (
                              <button
                                className='btn-link mostrar-res'
                                onClick={mostrar_resumen}>
                                <span>{i18n.t('resumen.resmosrs')}</span>
                                <CaretDown
                                  size={18}
                                  weight='bold'
                                />
                              </button>
                            )}
                          </div>
                          <div
                            className='row'
                            style={
                              state.guardado && !state.ver_resumen
                                ? { display: 'none' }
                                : { display: 'block' }
                            }>
                            <div className='col-sm-12 col-md-12 col-lg-12'>
                              <div className='checkout-card'>
                                <TiposPedido pedidoGuardado={state.guardado} />
                              </div>
                            </div>
                          </div>
                          <div
                            className='row'
                            style={
                              state.guardado && !state.ver_resumen
                                ? { display: 'none' }
                                : { display: 'block' }
                            }>
                            {forma_envio?.tipo && forma_envio.tipo === 'D' ? (
                              <div className='col-sm-12 col-md-12 col-lg-12'>
                                <div className='checkout-card'>
                                  <Transportistas pedidoGuardado={state.guardado} />
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div
                            className='row'
                            style={
                              state.guardado && !state.ver_resumen
                                ? { display: 'none' }
                                : { display: 'block' }
                            }>
                            <div className='col-sm-12 col-md-12 col-lg-12'>
                              <div className='checkout-card'>
                                {forma_envio?.tipo && forma_envio.tipo === 'D' ? (
                                  <DomiciliosEnvio
                                    editable={true}
                                    pedidoGuardado={state.guardado}
                                  />
                                ) : (
                                  ''
                                )}

                                {forma_envio?.tipo && forma_envio.tipo === 'T' ? (
                                  <Almacenes pedidoGuardado={state.guardado} />
                                ) : (
                                  ''
                                )}
                                {forma_envio?.tipo && forma_envio.tipo === 'R' ? (
                                  <Rutas pedidoGuardado={state.guardado} />
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>

                          <div
                            className='row'
                            style={
                              state.guardado && !state.ver_resumen
                                ? { display: 'none' }
                                : { display: 'block' }
                            }>
                            <div className='col-sm-12 col-md-12 col-lg-12'>
                              <div className='checkout-card'>
                                <FormasPago pedidoGuardado={state.guardado} />
                              </div>
                            </div>
                          </div>

                          {pedido && Object.keys(pedido).length > 0 ? (
                            <div
                              className='row'
                              style={
                                state.guardado && !state.ver_resumen
                                  ? { display: 'none' }
                                  : { display: 'block' }
                              }>
                              <div className='col-sm-12 col-md-12 col-lg-12'>
                                <div className='tt-shopcart-box checkout-card'>
                                  <h4 className='tt-title'>{i18n.t('resumen.resdat')}</h4>
                                  <p>{i18n.t('resumen.resdam')}</p>
                                  <div
                                    className='row'
                                    style={
                                      state.guardado && !state.ver_resumen
                                        ? { display: 'none' }
                                        : { display: 'flex' }
                                    }>
                                    <div className='col-sm-12 col-md-4 col-lg-4'>
                                      <PersonaPedido pedidoGuardado={state.guardado} />
                                    </div>

                                    <div className='col-sm-12 col-md-4 col-lg-4'>
                                      <NumeroPedidoCliente pedidoGuardado={state.guardado} />
                                    </div>

                                    <div className='col-sm-12 col-md-4 col-lg-4'>
                                      <CorreoPedido pedidoGuardado={state.guardado} />
                                    </div>

                                    <div className='col-sm-12 col-md-12 col-lg-12'>
                                      <PortesCasals pedidoGuardado={state.guardado} />
                                    </div>
                                    {/**

                                <div className='col-sm-12 col-md-4 col-lg-4'>
                                  <EmailPedido pedidoGuardado={state.guardado} />
                                </div>
                          **/}
                                  </div>
                                  <div className='row'>
                                    <div className='col-sm-12 col-md-12 col-lg-12'>
                                      <ObservacionesPedido pedidoGuardado={state.guardado} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <aside className='checkout-aside'>
                    {pedido?.lineas?.some(linea => linea.tipo_linea === 'P')
                      ? devuelveTotales()
                      : ''}
                    <div className='tt-shopcart-box tt-boredr-large'>
                      {pedido_cargando || lineas_pedido_cargando ? (
                        <Spinner showSpinner={pedido_cargando} />
                      ) : (
                        <>

                          {forma_pago?.pasarela === 'REDSYS' ? (
                            <PagarRedsys id_pedido={id_pedido_seleccionado || pedido.id_pedido} />
                          ) : forma_pago?.pasarela === 'PAYPAL' &&
                            pedido.forma_pago === forma_pago.codigo_forma_pago_web ? (
                            <PayPalPayment
                              handlePaymentSuccess={integrarPedido}
                              idPedidoPaypal={pedido.id_pedido_paypal}
                            />
                          ) : (
                            <button
                              className='btn btn-lg boton-pedido'
                              disabled={!isConfirmed}
                              onClick={pedirConfirmacion}>
                              <span className='icon icon-check_circle'></span>
                              {i18n.t('general.finalizr')}{' '}
                              {devuelveTextoBoton(es_pedido, es_presupuesto)}
                            </button>
                          )}
                          {!state.guardado ? (
                            <button
                              type='button'
                              className='btn btn-secondary btn-nuevo-pedido'
                              onClick={handleNuevoPedido}>
                              {i18n.t('resumen.newped')}
                            </button>
                          ) : (
                            ''
                          )}
                          <button
                            type='button'
                            className='btn-seguir-comprando'
                            onClick={handleSeguirComprando}>
                            <ArrowFatLineLeft size={18} />
                            <span>{i18n.t('general.contcomp')}</span>
                          </button>
                        </>
                      )}
                    </div>
                  </aside>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default Resumen
